import BasfiKindergartenConfig from '../dto/basfi/KindergartenConfig';
import Error from '../model/Error';
import axios from 'axios';

export default class BasfiKindergartenConfigRepository {
    static findByFederationId(federationId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/federations/${federationId}/basfi/kindergartens`)
                .then((response) => resolve(response.data.data.map((config) => BasfiKindergartenConfig.fromData(config))))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static findByKindergartenId(kindergartenId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/kindergartens/${kindergartenId}/basfi/config`)
                .then((response) => resolve(BasfiKindergartenConfig.fromData(response.data.data)))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static update(federationId, kindergartenConfigs) {
        return new Promise((resolve, reject) => {
            axios
                .put(`/federations/${federationId}/basfi/kindergartens`, {
                    configs: kindergartenConfigs.map((kindergartenConfig) => kindergartenConfig.serialize()),
                })
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }
}
